export enum FormTypesEnum {
  GATED = 'GATED',
  NEWSLETTER = 'NEWSLETTER',
  STANDARD = 'STANDARD',
  WEBINAR = 'WEBINAR'
}
